module.exports = __webpack_public_path__ + "media/documentSignature.9d7ce421.svg";